import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ActivationLoginLayout, AuthCheckLayout, LoginLayout } from '@/layouts';
import { EKioskRouterNames, ERouterNames } from '@/types';

const ForgotPasswordCreateNew = lazy(
  () => import('../pages/Login/pages/ForgotPasswordCreateNew'),
);

const ForgotPasswordEmailExisting = lazy(
  () => import('../pages/Login/pages/ForgotPasswordEmailExisting'),
);

const Login = lazy(() => import('../pages/Login/pages/Login'));

const LoginDevice = lazy(() => import('../pages/Login/pages/LoginDevice'));

const PageNotFound = lazy(() => import('../pages/PageNotFound'));

const PasswordResetConfirmation = lazy(
  () => import('../pages/Login/pages/PasswordResetConfirmation'),
);

const SentryErrorCheck = lazy(() => import('../pages/SentryErrorCheck'));

const Signup = lazy(() => import('../pages/Login/pages/Signup'));

const VerifyEmail = lazy(() => import('../pages/Login/pages/VerifyEmail'));

const ActivationKioskPage = lazy(
  () => import('@/pages/Login/pages/ActivationKiosk'),
);

export const publicRouters: RouteObject[] = [
  {
    path: EKioskRouterNames.KIOSK_ACTIVATION,
    element: <ActivationLoginLayout />,
    children: [
      {
        index: true,
        element: <ActivationKioskPage />,
      },
    ],
  },
  {
    element: <LoginLayout />,
    children: [
      {
        index: true,
        path: ERouterNames.LOGIN,
        element: <Login />,
      },
      {
        path: ERouterNames.FORGOT_PASSWORD,
        element: <ForgotPasswordEmailExisting />,
      },
      {
        path: ERouterNames.LOGIN_DEVICE,
        element: <LoginDevice />,
      },
      {
        path: ERouterNames.VERIFY_EMAIL,
        element: <VerifyEmail />,
      },
      {
        path: ERouterNames.PASSWORD_RESET_CONFIRMATION,
        element: <PasswordResetConfirmation />,
      },
      {
        path: ERouterNames.RESET_PASSWORD,
        element: <ForgotPasswordCreateNew />,
      },
      {
        path: ERouterNames.SIGNUP,
        element: <Signup />,
      },
    ],
  },
  {
    path: ERouterNames.SENTRY_CHECK,
    element: <SentryErrorCheck />,
  },
  {
    path: '/',
    element: <AuthCheckLayout />,
  },
  {
    path: '*',
    element: <PageNotFound />,
  },
];
